import { ApiSharingPartnerFormType } from 'components/api-sharing-partners/ApiSharingPartnerForm';

export const updateApiSharingPartnerInitialValues: Partial<ApiSharingPartnerFormType> = {};
